import api from '../lib/api'

export default {
	install (app) {
		app.provide('api', api);
	}
}